module.exports = __webpack_public_path__ + "media/btnLogin.41033ce5.mp3";